import api from "../../../../../../features/auth/axiosConfig";

export const fetchOrderDetails = (orderid: string) =>
  api.get(`/app/v1/pos/order/${orderid}`);

export const updateOrderStatus = (orderid: string, status: string) =>
  api.put(`/app/v1/pos/order/${orderid}`, { OrderStatus: status });

export const cancelOrder = (orderid: string) =>
  api.put(`/app/v1/pos/order/${orderid}`, { OrderStatus: "Cancelled" });

export const confirmPayment = (orderid: string, payload: any) =>
  api.patch(`/app/v1/pos/order/${orderid}`, payload);

export const fetchUsers = () =>
  api.get("/pos/get_user");


